import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoiceAddressDataDisplay',
  props: {
  type: {
    type: String as PropType<'sender' | 'recipient'>,
    required: true,
  },
  addressData: {
    type: Object as PropType<any>,
    required: true
  }
},
  setup(__props) {



return { __sfc: true, }
}

})